import { render, staticRenderFns } from "./ActionOpenHolder.vue?vue&type=template&id=aa651e34&"
import script from "./ActionOpenHolder.vue?vue&type=script&lang=js&"
export * from "./ActionOpenHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports